'use strict';

/**
 * Use to display layers from carto backend
 * Requires carto user info to create client: API key and username
 *
 *
 *
 * @param username Username of the carto account to be used
 * @param apiKey API-Key for the related account
 */
export default class CartoLayer {

    constructor(carto, username, apiKey) {
        this.carto = carto;
        this.client = new this.carto.Client({
            apiKey: apiKey,
            username: username
        });
    }

    /**
     * Create a carto layer and with given query and style and return leaflet-layer
     * @param config JSON containing the data for the layers.
     * @param layer layer definition
     * Requires: Layer array, containing sql and style params in an object
     * {
     *   "client": {
     *       "apiKey": "MY_API_KEY",
     *       "username": "MY_USERNAME"
     *   },
     *   "layers": [
     *       {
     *           "sql": "SELECT * FROM bw_fliwas_ezg_agg03_2018_02_10",
     *           "style": "#bw_fliwas_ezg_agg03_2018_02_10{ polygon-fill: #FFFFFF; polygon-opacity: 0; line-color: #000000; line-width: 2.5; line-opacity: 1;}"
     *       }
     *   ]
     * }
     * @returns {LeafletLayer}
     */
    createLayer(config, layer) {

        config.layers && config.layers.forEach(layer => {

            const source = new this.carto.source.SQL(layer.sql);
            const style = new this.carto.style.CartoCSS(layer.style);
            /*            const defaultKeys = layer.defaultKeys;
                        const columnNames = this.getColumnNames(layer.html).filter( (element, index) => defaultKeys.indexOf(element) === -1 );
                        const parsedAndDefaultColumnNames = defaultKeys.concat(columnNames);*/
            const cartoLayer = new this.carto.layer.Layer(source, style);
            //cartoLayer.on('featureClicked', (e) => this.openPopUp(e, map, layer.html, parsedAndDefaultColumnNames));

            this.client.addLayer(cartoLayer);
        });

        const defaultAttribution = '&copy; CARTO';
        const leafletLayer = this.client.getLeafletLayer({
            attribution: layer.attribution || defaultAttribution
        });
        leafletLayer.setZIndex(layer.zIndex || config.zIndex || 0);
        return leafletLayer;
    }

    /**
     * Open a static popup on the map.
     * @param featureEvent Clickevent
     * @param map Map element to open the popup on
     * @param html HTML string for popup
     * @param columnNames names of DB Cols
     */
    openPopUp(featureEvent, map, html, columnNames) {
        const popup = L.popup();
        let content = html;

        columnNames.forEach(name => {
            const featureProperty = featureEvent.data[name];
            content = content.replace('{{' + name + '}}', featureProperty || '');
        });

        content = content.replace('<a href="#close" class="cartodb-popup-close-button close">x</a>', '');
        popup.setContent(content);

        popup.setLatLng(featureEvent.latLng);
        if (!popup.isOpen()) {
            popup.openOn(map);
        }
    }

    getColumnNames(html) {
        let results = [];

        const res = html.split('{{');
        res.map((current, index) => {
            index !== 0 && results.push(current.slice(0, current.indexOf('}}')));
        });

        return results;
    }

}



// WEBPACK FOOTER //
// ./js/layer/CartoLayer.js